import type { QualityTier } from "@/demos/types";
import type { RuntimeMode } from "@/runtime/types";

export interface QualityPolicy {
  tier: QualityTier;
  dpr: number;
  antialias: boolean;
  shadows: boolean | "percentage";
}

export function isImmersiveMode(mode: RuntimeMode): boolean {
  return mode === "webxr" || mode === "eighth-wall";
}

export function qualityPolicy(tier: QualityTier, immersive = false): QualityPolicy {
  if (immersive) return { tier, dpr: 1, antialias: false, shadows: false };
  if (tier === "low") return { tier, dpr: 1, antialias: false, shadows: false };
  if (tier === "medium") return { tier, dpr: 1.25, antialias: true, shadows: false };
  return { tier, dpr: 1.5, antialias: true, shadows: "percentage" };
}

export function renderQualityForMode(tier: QualityTier, mode: RuntimeMode): QualityTier {
  return isImmersiveMode(mode) ? "low" : tier;
}

export function initialQualityTier(): QualityTier {
  const memory = (navigator as Navigator & { deviceMemory?: number }).deviceMemory;
  const cores = navigator.hardwareConcurrency;
  if ((memory !== undefined && memory <= 4) || cores <= 4) return "low";
  if ((memory !== undefined && memory <= 8) || cores <= 8) return "medium";
  return "high";
}
